// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1KrHw","info":"UpdateTermsInfo_info__4PVkk"};